module.exports = __webpack_public_path__ + "img/education.83c3ba80.webp";